var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: [_vm.namespace(), _vm.skinStyle] }, [
    _c(
      "ul",
      { class: [_vm.mdsNS("list-group"), _vm.namespace("group")] },
      _vm._l(_vm.dataModel, function(item) {
        return _c(
          "li",
          {
            key: item.id,
            class: [
              _vm.mdsNS("list-group__item"),
              item.disable ? _vm.mdsNS("list-group__item--disabled") : "",
              _vm.namespace("__item")
            ],
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.goToSubView(item)
              }
            }
          },
          [
            _c(
              "div",
              {
                class: [_vm.mdsNS("list-group__link"), _vm.namespace("__link")]
              },
              [
                _c(
                  "div",
                  {
                    class: [
                      _vm.mdsNS("list-group__item-label"),
                      _vm.namespace("__item-label")
                    ]
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      _vm.mdsNS("list-group__item-label"),
                      _vm.namespace("__item-label"),
                      _vm.namespace("__current-selection")
                    ]
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.name) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { class: _vm.namespace("__icon-wrapper") }, [
                  _c(
                    "svg",
                    {
                      class: _vm.mdsNS("icon"),
                      attrs: { "aria-labelledby": "title" }
                    },
                    [
                      _c("title", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      _c("use", { attrs: { "xlink:href": "#caret-right--s" } })
                    ]
                  )
                ])
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }